import React from "react";
// import { useNavigate } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import Banner from "./Banner";
import "./Product.css";
import ProductCard from "./ProductCard";
function Product() {
  const [{ products }] = useStateValue();
  // console.log(products[0][0], "productsData");
  return (
    <div className="product">
      
      <Banner />
      {products[0] &&
        products[0]?.map((item) => (
          <ProductCard
          
            key={item?.id}
            id={item?.id}
            brand={item?.brand}
            description={item?.description}
            images={item?.images}
            price={item?.price}
            rating={item?.rating}
            stock={item?.stock}
            thumbnail={item?.thumbnail}
            title={item?.title}
          />
        )
          )}
         </div>
  );
}

export default Product;
